export const confirmDiscardChanges = () =>
  window.confirm('未保存の変更があります。閉じてよろしいですか？')

// モーダルを閉じるのではなく編集を中断して前の表示に戻る場合に使う
export const confirmDiscardEdit = () =>
  window.confirm('未保存の変更があります。破棄してよろしいですか？')

// 対象名は各画面の成功通知で使っている名前に揃える
// （例：「メール通知を削除しました」→ confirmDelete('メール通知')）
export const confirmDelete = (target: string) =>
  window.confirm(`${target}を削除します。よろしいですか？`)

export const confirmBulkDelete = (count: number, unit: string) =>
  window.confirm(`選択した${count}件の${unit}を削除します。よろしいですか？`)

export const confirmCopy = (target: string) =>
  window.confirm(`${target}をコピーします。よろしいですか？`)

export const confirmUnpublishPage = () =>
  window.confirm('公開中のページを非公開にします。よろしいですか？')

export const confirmIssueIncentive = (count: number) =>
  window.confirm(
    `選択した${count}名を発行済みにします。\n発行済みは次回以降のリストに表示されなくなります。\nこの操作は元に戻せません。よろしいですか？`,
  )
